export class Contacto{
	nombre: string;	
	puesto: string;
	mail: string;
	telefono: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/empresa/contacto.ts